import { Box, Container, Grid, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { motion } from "framer-motion";

const ServiceOfferCards = ({ service }) => {
  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg">
        <Typography sx={styles.heading}>What We Offer</Typography>

        <Grid container spacing={3}>
          {service.offers.map((item, index) => (
            <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={index}>
              <motion.div whileHover={{ y: -10 }}>
                <Box sx={styles.card}>
                  <AutoAwesomeIcon
                    sx={{ color: service.accent, fontSize: 34 }}
                  />
                  <Typography sx={styles.cardText}>{item}</Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ServiceOfferCards;

const styles = {
  section: {
    py: { xs: 7, md: 10 },
    background: "none",
  },

  heading: {
    textAlign: "center",
    fontSize: { xs: "30px", md: "42px" },
    fontWeight: 800,
    mb: 6,
    color: "#071525",
  },

  card: {
    minHeight: 170,
    p: 3,
    borderRadius: "24px",
    background: "#fff",
    boxShadow: "0 20px 60px rgba(7,21,37,0.08)",
    border: "1px solid rgba(7,21,37,0.06)",
  },

  cardText: {
    mt: 2,
    fontSize: "17px",
    fontWeight: 600,
    color: "#1f2937",
    lineHeight: 1.5,
  },
};
